import { Icon } from "semantic-ui-react";
import MobileModal from "./MobileModal";
import { MobileModalBody } from "./MobileModalBody";
import { MobileModalHeader } from "./MobileModalHeader";
import { Appointment_Icons } from "./Events";
import { useMediaQuery } from "react-responsive";
import { eventIcons } from "../../_helper/constant/constant";
import { useNavigate } from "react-router-dom";
import { IoLogOut } from "react-icons/io5";
import { RiChatCheckLine, RiChatFollowUpLine } from "react-icons/ri";
import { checkPermission } from "../../../roles_and_permissions/_features";

const EventsSm = ({
  event,
  isOpen,
  closeModal,
  // handleBlock,
  // handleUnBlock,
  handleEditPatient,
  handleDecline,
  handleReschedule,
  handleStartConsultation,
  handlePreConsultation,
  handleEndConsultation,
  handleCreateInvoice,
  // handleOpenSlotClick,
  handleNoShow,
  // setIsMobileModal,
  dayCycle,
  permission,
}) => {
  const sm = !useMediaQuery({ query: "(min-width:1024px)" });
  const queryParams = new URLSearchParams(window.location.search);
  const navigate = useNavigate();
  const allClinic = queryParams.get("all_clinic");

  const handleMainSearch = (val) => {
    navigate(`/new/patient-options?all_clinic=${allClinic}&userId=${val}`);
  };

  let invoice_icon = Appointment_Icons.invoice;
  if (event?.event?.billing_status?.billing_status === "pending") {
    invoice_icon = Appointment_Icons.invoice_pending;
  }

  if (event?.event?.billing_status?.billing_status === "paid") {
    invoice_icon = Appointment_Icons.invoice_paid;
  }

  if (event?.event?.billing_status?.billing_status === "invoice not created") {
    invoice_icon = Appointment_Icons.invoice;
  }

  if (event?.event?.billing_status?.billing_status === "partially paid") {
    invoice_icon = Appointment_Icons.invoice_pending;
  }

  return (
    <MobileModal
      modalClassName={
        dayCycle == "week" && !sm ? "laptop-modal" : "modal-container"
      }
      isOpen={isOpen}
      closeModal={closeModal}
      event={event}
    >
      <MobileModalHeader>
        <span>{event.event.text}</span>
        <h4>{event?.event?.user_details?.full_name}</h4>
        <span>
          <span>{event?.event?.user_details?.age} yrs </span>
          <span>{event?.event?.user_details?.gender[0] || ""}</span>{" "}
        </span>
      </MobileModalHeader>
      <MobileModalBody>
        <div
          className={
            dayCycle == "week" && !sm ? `icons-laptop` : `icons-mobile`
          }
        >
          {checkPermission(permission?.allowed_features, 1005) && (
            <div onClick={() => handlePreConsultation(event?.event)}>
              <span className="inline-block text-3xl">
                {event?.event?.preconsultation ? (
                  <RiChatCheckLine size="34" color="green" />
                ) : (
                  <RiChatFollowUpLine size="34" color="red" />
                )}
              </span>
              <p>Pre-Consultation</p>
            </div>
          )}
          <div onClick={() => handleStartConsultation(event?.event, "mobile")}>
            <span className="inline-block text-3xl">
              <Icon
                size="34"
                style={{
                  color: "rgba(87, 208, 139, 1)",
                  width: "38px",
                  height: "38px",
                }}
                name="hourglass start"
              />
            </span>

            <p>Start Consultation</p>
          </div>
          {checkPermission(permission?.allowed_features, 1005) && (
            <div onClick={() => handleEndConsultation(event?.event)}>
              <span className="inline-block text-3xl">
                <IoLogOut size="34" color="red" />
              </span>
              <p>End Consultation</p>
            </div>
          )}
          <div>
            <span
              className="inline-block text-3xl"
              onClick={() => handleMainSearch(event?.event?.user_details?.id)}
            >
              {eventIcons?.viewProfile}{" "}
            </span>
            <p>View Profile</p>
          </div>

          <div onClick={() => handleReschedule(event?.event)}>
            <span className="inline-block text-3xl">
              {eventIcons?.reshedule}{" "}
            </span>
            <p>Reschedule</p>
          </div>

          <div onClick={() => handleCreateInvoice("OPD", event?.event, "sm")}>
            <span className="inline-block text-3xl">
              <img src={invoice_icon} width={"26px"} />
            </span>
            <p>Invoice</p>
          </div>

          <div onClick={() => handleDecline(event?.event)}>
            <span className="inline-block text-3xl">
              {eventIcons?.decline}{" "}
            </span>
            <p>Decline</p>
          </div>

          <div>
            <a href={`tel:${event?.event?.user_details?.phone}`}>
              <span className="inline-block text-3xl">{eventIcons?.call} </span>
            </a>

            <p>Call Patient</p>
          </div>

          <div onClick={() => handleEditPatient(event?.event)}>
            <span className="inline-block text-3xl"> {eventIcons?.edit}</span>
            <p>Edit</p>
          </div>
          <div>
            <div onClick={() => handleNoShow(event?.event)}>
              <span className="inline-block text-3xl">
                {eventIcons?.noShow}
              </span>

              <p>No Show</p>
            </div>
          </div>
        </div>
      </MobileModalBody>
    </MobileModal>
  );
};

export default EventsSm;
